import { render } from "./pensiun-list-custom.vue?vue&type=template&id=716a98aa"
import script from "./pensiun-list-custom.vue?vue&type=script&lang=js"
export * from "./pensiun-list-custom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__